import React, { useState, useEffect } from "react";
import { Loading } from "Components";
import toastService from "Root/profile/toastService";
import {
  apiGetPayPalId,
  apiCreatePaypalToken,
  apiStripe2braintree,
} from "Root/api/apiCheckout";

function PayPalButton(props) {
  const [paypalIsLoaded, setPaypalIsLoaded] = useState(false);
  const fetchPaypalData = async () => {
    try {
      const data = await apiGetPayPalId(); // not tested
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${data.paypalClientID}`;
      script.onload = renderBraintree();
      document.body.appendChild(script);
    } catch (e) {
      toastService.errorMessage("Something went wrong");
    }

    setPaypalIsLoaded(false);
  };

  useEffect(() => {
    fetchPaypalData();
  }, []);

  function create_client(auth) {
    braintree.client
      .create({
        authorization: auth,
      })
      .then((clientInstance) =>
        braintree.paypalCheckout.create({
          client: clientInstance,
        })
      )
      .then((paypalCheckoutInstance) =>
        paypalCheckoutInstance.loadPayPalSDK({
          vault: true,
          commit: false,
          intent: "tokenize",
        })
      )
      .then((paypalCheckoutInstance) =>
        paypal
          .Buttons({
            style: {
              height: 40,
              label: "paypal",
              color: "gold",
              shape: "rect",
              size: "medium",
              tagline: "false",
            },
            onShippingChange(data, actions) {
              if (
                data.shipping_address.country_code !== "US" &&
                data.shipping_address.country_code !== "CA"
              ) {
                return actions.reject();
              }
            },
            fundingSource: paypal.FUNDING.PAYPAL,
            createBillingAgreement() {
              return paypalCheckoutInstance.createPayment({
                flow: "vault",
                billingAgreementDescription:
                  "You will not be charged upon completing this form, we will use the form to update your information.",
                enableShippingAddress: true,
                shippingAddressEditable: true,

                displayName: "Gainful Health Inc.",
                amount: 0,
                currency: "USD",
              });
            },
            onApprove(data) {
              props.setLoading(true);
              return paypalCheckoutInstance.tokenizePayment(
                data,
                (err, payload) => {
                  // Submit `payload.nonce` to your server.
                  const data = {
                    nonce: payload.nonce,
                    shipAddress: JSON.stringify(
                      payload.details.shippingAddress
                    ),
                    paymentType: "paypal",
                  };
                  apiStripe2braintree(data)
                    .then((resp) => {
                      props.setCardsData(resp.card_data);
                      props.setLoading(false);
                    })
                    .catch((e) => {
                      toastService.errorMessage("Something went wrong");
                      props.setLoading(false);
                    });
                }
              ); // end tokenizePayment
            }, // end on Approve
            onCancel(data) {
              console.log(
                "paypal switch cancelled",
                JSON.stringify(data, 0, 2)
              );
            },
            onError(err) {
              console.error("paypal error", err);
              props.setLoading(false);
            },
          })
          .render("#paypal-button-1")
      )
      .then(() => {
        // The PayPal button will be rendered in an html element with the ID
        // `paypal-button`. This function will be called when the PayPal button
        // is set up and ready to be used
        setPaypalIsLoaded(true);
      })
      .catch((err) => {
        // Handle component creation error
        console.log("error: ", err);
      });
  }

  async function renderBraintree() {
    try {
      const data = await apiCreatePaypalToken({});
      create_client(data.token);
    } catch (err) {
      toastService.errorMessage("Something went wrong");
    }
    // postRequestWithAuth("/api/create-paypal-token/", {}, (data) => { // not tested
    //   create_client(data.token);
    // });
  }

  return (
    <>
      {!paypalIsLoaded && <Loading />}
      <div id="paypal-button-1" style={{ zIndex: "0" }} />
    </>
  );
}

export default PayPalButton;
